import React from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import './BlogSection.css';

import img1 from '../assets/news-1.jpg';
import img2 from '../assets/news-2.jpg';
import img3 from '../assets/news-3.jpg';

const blogPosts = [
  {
    id: 1,
    title: 'Media To Promote Your Upcoming Event',
    date: '20 APR',
    tag: 'EVENTS',
    img: img1,
    desc: 'Discover effective media channels and strategies to maximize the reach and impact of your upcoming corporate event, ensuring strong attendance.',
  },
  {
    id: 2,
    title: 'Strategies For Cost-Effective Planning',
    date: '20 APR',
    tag: 'EVENTS',
    img: img2,
    desc: 'Learn practical tips and innovative approaches to plan memorable events without breaking your budget, optimizing every resource for maximum value.',
  },
  {
    id: 3,
    title: 'Theme Ideas To Make Your Event',
    date: '20 APR',
    tag: 'EVENTS',
    img: img3,
    desc: 'Explore creative and trending theme ideas that will set your corporate event apart, creating a unique atmosphere that resonates with your audience.',
  }
];


const BlogSection = () => {
  return (
    <section className="blog-section py-5">
      <Container>
        <div className="text-center mb-5">
          <p className="section-subtitle">INSIGHTS & INSPIRATION</p>
          <h2 className="section-title">
            Lets Discover Our Blog Post <br /> And News Content.
          </h2>
          <Button className="discover-btn">Discover Blog →</Button>
        </div>
    <Row className="g-4">
  {blogPosts.map((post, index) => {
    let animation;
    if (index === 0) animation = 'fade-right';
    else if (index === 1) animation = 'fade-up';
    else animation = 'fade-left';

    return (
      <Col md={4} key={post.id} data-aos={animation}>
        <Card className="blog-card">
          <div className="card-image-wrapper">
            <Card.Img variant="top" src={post.img} className="rounded-top" />
            <div className="tag">{post.tag}</div>
            <div className="date-badge">{post.date}</div>
          </div>
          <Card.Body>
            <Card.Title>{post.title}</Card.Title>
            <Card.Text>{post.desc}</Card.Text>
            <a href="/" className="read-more">Read More →</a>
          </Card.Body>
        </Card>
      </Col>
    );
  })}
</Row>

      </Container>
    </section>
  );
};

export default BlogSection;
